<template>
    <div class="version__entry">
        <h3 class="version__title">{{data.version_number}} - {{data.uploaded}}</h3>
        <div class="version__text">
            {{data.changelog}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>
    .version__entry{
        border: 1px solid #D9D9D9;
        padding: 25px;
        margin-bottom: 20px;
        cursor: pointer;
        background-color: #FFFFFF;
    }

    .version__entry:last-child{
        margin-bottom: 0;
    }
    .version__title{
        
        background-color: #FFFFFF;
        font-size: 26px;
        line-height: 34px;
        font-weight: bold;
        margin: 0;
        color: #575C61;
    }
    .version__text{
        padding-top: 25px;
        display: block;
    }
</style>